export default __webpack_public_path__ + "static/media/Read-Regular_V1100.9afed271.woff";